import * as Yup from 'yup';
import { OrganisationType } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<OrganisationType>().shape({
    name: Yup.string().nullable().required(),
  });
}
